<template>
  <div>
    <StickyHScroll>
      <v-data-table-server
        v-model:options="pagination"
        :items="computedParts"
        :headers="headers"
        :items-length="totalItems"
        :items-per-page="pagination.itemsPerPage"
        :items-per-page-options="[
          { value: 5, title: '5' },
          { value: 10, title: '10' },
          { value: 25, title: '25' },
          { value: 50, title: '50' },
        ]"
        items-per-page-text="Rows per page"
        item-value="_id"
        return-object
        :loading="loading"
        class="elevation-1 nowrap-headers pb-8"
        @update:options="updatePagination"
      >
      <template #progress>
        <v-progress-linear color="red" indeterminate />
      </template>

      <template #group="props">
        <v-row align-center row>
          <span v-if="props.groupName" class="ml-5 mr-2">{{
            $t("insert_parts.kit_qr")
          }}</span>
          <span v-if="props.groupName" class="ma-1">
            <qr-code :size="50" :text="props.groupName" />
          </span>
        </v-row>
      </template>
      <!----------------------------------------MAIN TABLE----------------------------------------->
      <template #item="{ item, index }">
        <tr
          :class="{ tableRowColorSelected: index == activeRow }"
          class="tableRowColor"
          @click="activeRow = index"
        >
          <!----------------------------------------QR CODE---------------------------------------->
          <td class="ma-1 pt-1 pb-1">
            <v-row
              class="pointer ma-1 text-center justify-center d-flex flex-column"
              @click.stop="
                openQrDialog({
                  id: item._id,
                  type: 'temporary-parts',
                  printed: item.printed,
                  car: item.car_id,
                })
              "
            >
              <qr-code :size="70" :text="item._id" />
              <h4>
                {{ item._id.slice(item._id.length - 6, item._id.length) }}
              </h4>
            </v-row>
          </td>
          <!----------------------------------------ACTIONS---------------------------------------->
          <td class="justify-center">
            <v-row row>
              <v-btn icon variant="text" @click="openActionsDialog(item)">
                <v-icon color="grey-darken-2"> mdi-compare-horizontal </v-icon>
              </v-btn>
            </v-row>
          </td>
          <!-------------------------------------AVAILABILITY-------------------------------------->
          <!-- <td v-if="item.active">
            <v-chip label variant="outlined" color="error">
              {{ $t("leko_employees.approve_parts.table.unavailable") }}
            </v-chip>
          </td>
          <td v-else>
            <v-chip label variant="outlined" color="success">
              {{ $t("leko_employees.approve_parts.table.available") }}
            </v-chip>
          </td>
          -->
          <!--------------------------------SENT FOR APPROVAL DATE--------------------------------->
          <td>
            <span v-if="item.sentForApproval">
              {{ formatDate(item.sentForApproval.date) }}
            </span>
          </td>
          <!------------------------------------------OEM------------------------------------------>
          <td>
            <v-icon v-if="item.oemCodes && item.oemCodes.length > 0">
              mdi-check-circle-outline
            </v-icon>
          </td>
          <!----------------------------------------IMAGES----------------------------------------->
          <td>
            <img
              :src="
                item.images && item.images.length > 0 && item.images[0].thumb
                  ? `https://leko-tech.fra1.cdn.digitaloceanspaces.com/${item.images[0].thumb}`
                  : `https://portal.lekotech.com/logo_small.png`
              "
              class="ma-1 pointer"
              height="75"
              width="100"
              @click="showImages(item._id, item.images, item.date_created)"
            />
          </td>
          <!--------------------------------CONDITION NEW--------------------------------->
          <td class="text-xs-center">
            <span v-if="item.isNewPart">
              <v-icon>mdi-check-circle-outline</v-icon>
            </span>
          </td>
          <!--------------------------------CLASSIFICATION WITH AI--------------------------------->
          <td class="text-xs-center">
            <span
              v-if="
                item.classificationWithAI &&
                item.classificationWithAI.toLowerCase().includes('error')
              "
            >
              Image not analyzed
            </span>
            <span v-else>
              {{ item.classificationWithAI }}
            </span>
          </td>
          <!------------------------------------------PRA------------------------------------------>
          <td class="text-xs">
            {{ item.pra }}
          </td>
          <!---------------------------------------SHIPMENT---------------------------------------->
          <td
            v-if="item.shipment_id"
            class="text-xs"
            style="min-width: 200px !important"
          >
            <a v-if="item.car_id" @click="viewCar(item.car_id._id)">
              {{ item.shipment_id.name }}
            </a>
            <span v-else> {{ item.shipment_id.name }} </span>
          </td>
          <td v-else class="text-xs" />
          <!------------------------------------------CAD------------------------------------------>
          <td class="text-xs">
            <v-btn
              v-if="item.car_id"
              icon
              variant="text"
              @click="openInfoCarCad(item.car_id)"
            >
              <v-icon color="grey-darken-3">mdi-car</v-icon>
            </v-btn>
            <v-btn v-else icon variant="text" disabled>
              <v-icon color="grey-darken-3">mdi-car-off</v-icon>
            </v-btn>
          </td>
          <!-----------------------------------------NOTES----------------------------------------->
          <td class="text-xs">
            <v-row
              align="center"
              justify="center"
              class="pointer"
              style="min-width: 125px !important"
              @click="showNotes(item.notes)"
            >
              <span v-if="item.notes && item.notes.length > 40">
                {{ item.notes.substring(0, 40) }}...
                <v-icon>mdi-eye</v-icon>
                {{ item.notes ? "(" + item.notes.length + ")" : "" }}
              </span>
              <span v-else
                >{{ item.notes }}
                {{ item.notes ? "(" + item.notes.length + ")" : "" }}</span
              >
            </v-row>
          </td>

          <!--------------------------------------INSTITUTION-------------------------------------->
          <td v-if="item.institution_id" class="text-xs">
            <v-chip>
              {{ item.institution_id.title }}
            </v-chip>
          </td>
          <td v-else class="text-xs" />
          <!-----------------------------------------USER------------------------------------------>
          <td v-if="item.user_id" class="text-xs">
            {{ item.user_id.name }}
          </td>
          <td v-else class="text-xs" />
          <td v-if="item.user_id" class="text-xs">
            {{ item.user_id.surname }}
          </td>
          <td v-else class="text-xs" />
          <!----------------------------------------------------------------------------------------->
        </tr>
      </template>
      <!------------------------------------------------------------------------------------------->
      </v-data-table-server>
    </StickyHScroll>
    <v-dialog v-model="getCountedModal" width="600">
      <v-card flat class="pa-3">
        <div v-if="loadingAll">
          <v-progress-circular color="#D32F2F" indeterminate size="100" />
        </div>
        <div v-else>
          <div>
            <h2>
              {{ $t("leko_employees.approve_parts.waiting_for_approval") }}
            </h2>
          </div>
          <v-list>
            <template v-for="(inst, index) in counted" :key="index">
              <v-list-item>
                <v-row no-gutters align="center" class="w-100">
                  <div class="font-weight-bold">
                    {{ inst.title }}
                  </div>
                  <v-spacer />
                  <v-chip color="red" text-color="white">
                    {{ inst.count }}
                  </v-chip>
                </v-row>
              </v-list-item>

              <v-divider v-if="index < counted.length - 1" />
            </template>
          </v-list>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import VueQrCode from "vue-qr-generator";

import getRequest from "../../api/getRequest";

export default {
  components: {
    "qr-code": VueQrCode,
  },
  props: ["search"], // eslint-disable-line vue/require-prop-types
  data: () => ({
    activeRow: null,
    expand: false,
    loading: false,
    loadingAdditional: false,
    headers: [
      {
        title: "Qr Code",
        sortable: true,
        key: "_id",
      },
      {
        title: "Actions",
        sortable: false,
        key: "actions",
      },
      // {
      //   title: "Availability",
      //   sortable: false,
      //   key: "active",
      // },
      {
        title: "Sent For Approval",
        sortable: true,
        key: "sentForApproval.date",
      },
      {
        title: "OEM",
        sortable: false,
        key: "oemCodes",
      },
      {
        title: "Images",
        sortable: false,
        key: "images",
      },
      {
        title: "New",
        sortable: false,
        key: "isNewPart",
      },
      {
        title: "Classification with AI",
        sortable: false,
        key: "classificationWithAI",
      },
      {
        title: "Pra",
        sortable: false,
        key: "pra",
      },
      {
        title: "Shipment",
        sortable: false,
        key: "shipment_id.name",
      },
      {
        title: "Cad",
        sortable: false,
        key: "cad",
      },
      {
        title: "Notes",
        sortable: false,
        key: "notes",
      },
      {
        title: "Institution",
        sortable: true,
        key: "institution_id",
      },
      {
        title: "Name",
        sortable: false,
        key: "user_id.name",
      },
      {
        title: "Surname",
        sortable: false,
        key: "user_id.surname",
      },
      // {
      //   title: 'Audio',
      //   sortable: false,
      //   key: '',
      // },
    ],
    pagination: {
      itemsPerPage: 5,
      page: 1,
      groupBy: ["sentForApproval.date"],
      sortBy: { key: "sentForApproval.date", order: "desc" },
      sortDesc: [true],
    },
    parts: [],
    additionalParts: [],
    totalItems: 0,
    activeParts: [],
    counted: [],
    getCountedModal: false,
    loadingAll: false,
  }),
  computed: {
    server() {
      return this.$serverUri;
    },
    role() {
      return this.$store.getters.role;
    },
    searchObject() {
      return this.$props.search;
    },
    computedParts() {
      const parts = [];
      this.parts.forEach((p) => {
        const part = p;
        this.activeParts.forEach((activePart) => {
          if (activePart.part === part._id) {
            part.active = true;
          }
        });
        parts.push(part);
      });
      return parts;
    },
  },
  watch: {
    pagination: {
      handler() {
        if (this.searchObject.type === null) {
          this.getParts();
        } else if (this.searchObject.type === "regularSearch") {
          this.regularSearch(this.searchObject.data);
        } else if (this.searchObject.type === "advancedSearch") {
          this.advancedSearch(this.searchObject.data);
        } else {
          //
        }
      },
    },
    searchObject: {
      handler(value) {
        if (value.type === null) {
          this.getParts();
        } else if (value.type === "regularSearch") {
          this.regularSearch(value.data);
        } else if (value.type === "advancedSearch") {
          this.advancedSearch(value.data);
        } else {
          //
        }
      },
    },
    parts(value) {
      this.$emit("items", value);
    },
  },
  mounted() {
    this.getLocale();
  },
  methods: {
    getLocale() {
      this.headers[0].title = this.$t(
        "leko_employees.approve_parts.table.qr_code",
      );
      this.headers[1].title = this.$t(
        "leko_employees.approve_parts.table.actions",
      );
      // this.headers[2].title = this.$t(
      //   "leko_employees.approve_parts.table.availability",
      // );
      this.headers[2].title = this.$t(
        "leko_employees.approve_parts.table.sent_for_approval",
      );
      this.headers[3].title = this.$t("leko_employees.approve_parts.table.oem");
      this.headers[4].title = this.$t(
        "leko_employees.approve_parts.table.images",
      );
      this.headers[5].title = this.$t("leko_employees.approve_parts.table.new");
      this.headers[6].title = this.$t("parts.table.classification_with_ai");
      this.headers[7].title = this.$t("leko_employees.approve_parts.table.pra");
      this.headers[8].title = this.$t(
        "leko_employees.approve_parts.table.shipment",
      );
      this.headers[9].title = this.$t(
        "leko_employees.approve_parts.table.cad",
      );
      this.headers[10].title = this.$t(
        "leko_employees.approve_parts.table.notes",
      );
      this.headers[11].title = this.$t(
        "leko_employees.approve_parts.table.institution",
      );
      this.headers[12].title = this.$t(
        "leko_employees.approve_parts.table.name",
      );
      this.headers[13].title = this.$t(
        "leko_employees.approve_parts.table.surname",
      );
      // this.headers[14].title = this.$t('leko_employees.approve_parts.table.audio');
    },
    getParts() {
      this.loading = true;
      const sort = this.pagination.sortBy?.[0] || {
        key: "sentForApproval.date",
        order: "desc",
      };
      Promise.all([
        getRequest(
          "/temporary-part/approve/datatable",
          `institution_id=${this.$store.getters.institutionId}&role=${
            this.$store.getters.role
          }&limit=${this.pagination.itemsPerPage}&page=${
            this.pagination.page
          }&sort_by=${sort.key}&descending=${sort.order === "desc"}`,
        ),
      ])
        .then((response) => {
          this.totalItems = response[0].count;
          this.parts = response[0].temporaryParts;
          // this.activeParts = response[1];
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getAdditionalParts(kitId, expanded) {
      if (expanded && kitId) {
        this.loadingAdditional = true;
        getRequest("/temporary-part/additional", `kit_id=${kitId}`)
          .then((response) => {
            this.additionalParts = response.temporaryParts;
            this.loadingAdditional = false;
          })
          .catch(() => {
            this.additionalParts = [];
            this.loadingAdditional = false;
          });
      } else {
        this.additionalParts = [];
      }
    },
    regularSearch(data) {
      this.loading = true;
      const sort = this.pagination.sortBy?.[0] || {
        key: "sentForApproval.date",
        order: "desc",
      };
      Promise.all([
        getRequest(
          "/temporary-part/approve/search/regular",
          `type=${data.searchType}&role=${this.$store.getters.role}&limit=${
            this.pagination.itemsPerPage
          }&page=${this.pagination.page}&sort_by=${sort.key}&descending=${
            sort.order === "desc"
          }&search=${data.searchField}`,
        ),
      ])
        .then((response) => {
          this.totalItems = response[0].count;
          this.parts = response[0].temporaryParts;
          // this.activeParts = response[1];
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    advancedSearch(data) {
      this.loading = true;
      const sort = this.pagination.sortBy?.[0] || {
        key: "sentForApproval.date",
        order: "desc",
      };
      Promise.all([
        getRequest(
          "/temporary-part/approve/search/advanced",
          `type=${data.searchType}&institution=${data.institution}&role=${
            this.$store.getters.role
          }&limit=${this.pagination.itemsPerPage}&page=${
            this.pagination.page
          }&sort_by=${sort.key}&descending=${sort.order === "desc"}&search=${
            data.searchField
          }&start_date=${data.startDate}&end_date=${data.endDate}`,
        ),
      ])
        .then((response) => {
          this.totalItems = response[0].count;
          this.parts = response[0].temporaryParts;
          // this.activeParts = response[1];
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    advancedSearchAdmin(data) {
      this.loadingAll = true;
      Promise.all([
        getRequest(
          "/temporary-part/approve/search-admin/superAdmin",
          `institutions=${data.institution}&role=${this.$store.getters.role}`,
        ),
      ])
        .then((response) => {
          if (response && response[0]) {
            this.counted = response[0];
            this.loadingAll = false;
            this.getCountedModal = true;
          }
        })
        .catch((error) => {
          if (error) {
            this.loadingAll = false;
          }
        })
        .finally(() => {
          this.loadingAll = false;
        });
    },
    openQrDialog(data) {
      this.$emit("qr", data);
    },
    showImages(id, images, date) {
      this.$emit("images", {
        type: "string",
        id,
        images,
        date,
      });
    },
    openActionsDialog(data) {
      this.$emit("actions", data);
    },
    updatePagination(options) {
      this.pagination = {
        ...options,
        itemsPerPage: options.itemsPerPage ? options.itemsPerPage : 5,
        groupBy:
          options.groupBy && options.groupBy.length
            ? options.groupBy
            : ["sentForApproval.date"],
        sortBy:
          options.sortBy && options.sortBy.length
            ? options.sortBy
            : { key: "sentForApproval.date", order: "desc" },
        sortDesc:
          options.sortDesc && options.sortDesc.length
            ? options.sortDesc
            : [true],
      };
      this.activeRow = null;
    },
    openInfoCarCad(data) {
      this.$emit("infocar-cad", data);
    },
    viewCar(carId) {
      this.$emit("view-car", { carId });
    },
    showNotes(notes) {
      this.$emit("show-notes", notes);
    },
    formatDate(date) {
      if (!date) return "";
      moment.locale(localStorage.getItem("language") || "en");
      return moment(date).format("LLL");
    },
  },
};
</script>
